__turbopack_context__.v({
  "trustpilotSupportRichText": "jb988G_trustpilotSupportRichText",
  "trustpilotWrapper": "jb988G_trustpilotWrapper",
});
